"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isIframeCommand = void 0;
const isIframeCommand = (variable) => {
    if (typeof variable === 'object' && typeof variable.action === 'string') {
        if (variable.action === 'init') {
            return true;
        }
        if (variable.action === 'scroll' && typeof variable.scroll === 'string') {
            return true;
        }
        if (variable.action === 'redirect' &&
            typeof variable.path === 'string' &&
            (typeof variable.messages === 'undefined' ||
                isArrayOfStrings(variable.messages))) {
            return true;
        }
        if (['replaceWithMessages', 'displayMessages'].includes(variable.action) &&
            isArrayOfStrings(variable.messages)) {
            return true;
        }
    }
    return false;
};
exports.isIframeCommand = isIframeCommand;
const isArrayOfStrings = (variable) => Array.isArray(variable) && !variable.find((item) => typeof item !== 'string');
